import { formatCurrency, transformDateToLocalDateString } from "helpers";
import { InvoiceIncomingPayment } from "services/api/finance/incoming-invoices/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const INCOMING_INVOICE_PAYMENTS_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
  {
    title: "Datum",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <div className="text-sm">{transformDateToLocalDateString(row.paidAt)}</div>
    ),
  },
  {
    title: "Iznos",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <div className="text-sm font-medium text-green-600">{formatCurrency.format(row.amount)}</div>
    ),
  },
  {
    title: "Metoda",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <div className="text-sm text-slate-500">{row.paymentMethodName ?? "-"}</div>
    ),
  },
  {
    title: "Referenca",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <div className="text-sm text-slate-500">{row.paymentReference ?? "-"}</div>
    ),
  },
  {
    title: "Napomena",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <div className="text-sm text-slate-400 truncate max-w-[150px]">{row.note ?? "-"}</div>
    ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingPayment) => (
      <ButtonMenu
        endIcon="/media/icons/more-dots.svg"
        cssClassName="h-full"
        variant="text"
      >
        <ButtonMenuItem
          startIcon="/media/icons/trash.svg"
          variant="remove"
          onClick={(e) => handleDeleteClick(e, row.id)}
        >
          Obriši
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
